import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { NvIconModule } from '../nv-icon/nv-icon.module';
import { NvPillComponent } from './nv-pill.component';

@NgModule({
  imports: [CommonModule, NvIconModule],
  declarations: [NvPillComponent],
  exports: [NvPillComponent],
})
export class NvPillModule {}
